import { Map } from "immutable";
import { resolveEach } from "redux-resolver";
import {
  BOOKMARKS,
  CACHED_SALES_CART,
  REPAIR_CART_ITEMS,
  SALES_CART_ITEMS,
  USER
} from "MODULES/users/constants";
import session from "APP_ROOT/session";
import * as actionTypes from "./actionTypes";

export const initialState = Map({
  user: Map(),
  settings: Map(),
  loginError: null,
  pushId: null,
  [BOOKMARKS]: Map(),
  [REPAIR_CART_ITEMS]: Map(),
  [SALES_CART_ITEMS]: Map(),
  [CACHED_SALES_CART]: Map()
});

function login(state, action) {
  return state.merge({
    user: action.user,
    settings: action.settings
  });
}

function update(state, action) {
  return state.merge({
    user: action.user
  });
}

function refreshCart(state, action) {
  const {
    bookmarks,
    repair_order_cart_items: repairCartItems,
    sales_order_cart_items: salesCartItems,
    cached_sales_cart: cachedSalesCart
  } = action.user;

  session.setRepairCartItems(repairCartItems);
  session.setSalesCartItems(salesCartItems);
  session.setBookmarks(bookmarks);

  return state.merge({
    bookmarks,
    cachedSalesCart,
    repairCartItems,
    salesCartItems
  });
}

function setCarts(state, action) {
  const { bookmarks, repairCartItems, salesCartItems } = action;

  session.setRepairCartItems(repairCartItems);
  session.setSalesCartItems(salesCartItems);
  session.setBookmarks(bookmarks);

  return state.merge({
    bookmarks,
    repairCartItems,
    salesCartItems
  });
}

function loginError(state, action) {
  return state.set("loginError", action.message);
}

function setPushId(state, action) {
  return state.set("pushId", action.pushId);
}

function setSettings(state, action) {
  const user = state.get(USER).toJS();
  user.locations = action.locations;
  session.login(user);
  return state.merge({ settings: action.settings, user });
}

export function setLocations(state, action) {
  const user = state.get(USER).toJS();
  user.locations = action.locations;
  session.login(user);
  return state.merge({ user });
}

export function refreshSalesCart(state, action) {
  session.setSalesCartItems(action.salesCartItems);

  return state.merge({
    cachedSalesCart: action.cachedSalesCart,
    salesCartItems: action.salesCartItems
  });
}

function clear() {
  return initialState;
}

export default resolveEach(initialState, {
  [actionTypes.LOGIN]: login,
  [actionTypes.LOGIN_ERROR]: loginError,
  [actionTypes.CLEAR]: clear,
  [actionTypes.PUSH_ID]: setPushId,
  [actionTypes.REFRESH_CARTS]: refreshCart,
  [actionTypes.REFRESH_CACHED_SALES_CARTS]: refreshSalesCart,
  [actionTypes.SET_LOCATIONS]: setLocations,
  [actionTypes.SET_SETTINGS]: setSettings,
  [actionTypes.SET_CARTS]: setCarts,
  [actionTypes.UPDATE]: update
});



// WEBPACK FOOTER //
// ./app/modules/session/reducer.js